import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventEditor = _resolveComponent("EventEditor")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('acp.event_edit'),
    gap: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_EventEditor, {
        "event-types": _ctx.eventTypes,
        event: _ctx.event,
        "emit-actions": true,
        onSubmit: _ctx.submit
      }, null, 8, ["event-types", "event", "onSubmit"])
    ]),
    _: 1
  }, 8, ["title"]))
}